<template>
  <v-item-group active-class="primary">
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <v-item v-slot:default="{ active, toggle }">
            <BlogDrops />

            <!--
            <v-card :loading="loading" class="mx-auto my-12" max-width="474">
              <v-img height="250" :src="image01"></v-img>

              <v-card-title>Drops no Blog</v-card-title>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    :value="4.5"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="14"
                  ></v-rating>

                  <div class="grey--text ml-4">4.5 (413)</div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  * • Blog, Novidades
                </div>

                <div>
                  O VIOLENT NOISE indica as novidades do cenário Underground.
                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-title>Veja as novidades</v-card-title>

              <v-card-actions>
                <v-btn color="deep-purple accent-4" text @click="showBlog">
                  Visualizar
                </v-btn>
              </v-card-actions>
            </v-card>
-->
          </v-item>
        </v-col>
        <v-col cols="12" md="4">
          <v-item v-slot:default="{ active, toggle }">
            <Facebook />
            <!--            
            <v-card :loading="loading" class="mx-auto my-12" max-width="474">
              <v-img height="250" :src="image02"></v-img>

              <v-card-title>Visite-nos FaceBook</v-card-title>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    :value="4.5"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="14"
                  ></v-rating>

                  <div class="grey--text ml-4">4.5 (413)</div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  * • Facebook, Noticias
                </div>

                <div>
                  O VIOLENT NOISE esta no Facebook, trazendo todas as noticias das bandas mais importantes do Brasil.
                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-title>Veja as noticias</v-card-title>

              <v-card-actions>
                <v-btn color="deep-purple accent-4" text @click="showFacebook">
                  Visualizar
                </v-btn>
              </v-card-actions>
            </v-card>
-->
          </v-item>
        </v-col>
        <v-col cols="12" md="4">
          <v-item v-slot:default="{ active, toggle }">
            <ViolentNoise />
            <!--            
            <v-card :loading="loading" class="mx-auto my-12" max-width="474">
              <v-img height="250" :src="image03"></v-img>

              <v-card-title>Sobre o Violent Noise</v-card-title>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    :value="4.5"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="14"
                  ></v-rating>

                  <div class="grey--text ml-4">4.5 (413)</div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  + • Violent Noise, Projeto, Descrição
                </div>

                <div>
                  O VIOLENT NOISE foi idealizado e criado por Pierre Cortes.
                  Paulistano, apreciador do Rock, Metal e suas subdivisões desde
                  o início dos anos 80, o objetivo de criar o projeto foi
                  justamente a necessidade de difundir, fortalecer e
                  compartilhar o cenário Underground e as bandas que dele fazem
                  parte. Stay Rock!
                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-title>Entre em contato</v-card-title>

              <v-card-text>
                <v-chip-group
                  v-model="selection"
                  active-class="deep-purple accent-4 white--text"
                  column
                >
                  <v-chip>pierre@violentnoise.com.br</v-chip>

                  <v-chip>twitter: @pierre</v-chip>

                  <v-chip>messenger: pierre.cortez@hotmail.com</v-chip>

                  <v-chip>whatsapp: (11) 834838-884989</v-chip>
                </v-chip-group>
              </v-card-text>

              <v-card-actions>
                <v-btn color="deep-purple accent-4" text @click="reserve">
                  Envie um email
                </v-btn>
              </v-card-actions>
            </v-card>
-->
          </v-item>
        </v-col>
      </v-row>
    </v-container>
  </v-item-group>
</template>

<script>
import BlogDrops from "@/components/Cards/BlogDrops.vue";
import Facebook from "@/components/Cards/Facebook.vue";
import ViolentNoise from "@/components/Cards/ViolentNoise.vue";

const image1 = require("@/assets/images/content/audience-celebration.jpg");
const image2 = require("@/assets/images/content/drums.jpg");
const image3 = require("@/assets/images/content/guitar.jpg");
const image4 = require("@/assets/images/content/audio-cassette.jpg");

export default {
  name: "Conteudo",
  components: { BlogDrops, Facebook, ViolentNoise },
  data: () => ({
    image01: image1,
    image02: image2,
    image03: image3,
    image04: image4,
    loading: false,
    selection: 0
  }),

  methods: {
    showBlog: function() {
      this.$store.commit("setIsBlogPost", true);
    },
    showFacebook: function() {
      this.$store.commit("setIsFacebook", true);
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    }
  }
};
</script>
<style></style>
